import _ from 'lodash'

/* eslint-disable */
// disabling due to line length

let translations = null

export const globalTranslations = {
    // user managment page
    single_user : {
        en: `user`,
        fi: `käyttäjä`
    },
    multiple_users : {
        en: `users`,
        fi: `käyttäjää`
    },
    user: {
        en: `User`,
        fi: `Normaali`
    },
    manager: {
        en: `Coordinator`,
        fi: `Hallinnointi`
    },
    coordinator: {
        en: `Coordinator`,
        fi: `Hallinnointi`
    },
    member: {
        en: `Member`,
        fi: `Jäsen`
    },
    editor: {
        en: `Editor`,
        fi: `Muokkaus`
    },
    roleUser: {
        en: `Switch role to User`,
        fi: `Vaihda rooliksi Normaali`
    },
    roleMember: {
        en: `Switch role to Member`,
        fi: `Vaihda rooliksi Jäsen`
    },
    roleEditor: {
        en: `Switch role to Editor`,
        fi: `Vaihda rooliksi Muokkaus`
    },
    roleManager: {
        en: `Switch role to Coordinator`,
        fi: `Vaihda rooliksi Hallinnointi`
    },
    roleCoordinator: {
        en: `Switch role to Coordinator`,
        fi: `Vaihda rooliksi Hallinnointi`
    },
    roleRemove: {
        en: `Remove from group`,
        fi: `Poista ryhmästä`
    },
    usersManagment: {
        en: `Users`,
        fi: `Käyttäjät`
    },
    manageUsers: {
        en: `Manage Users`,
        fi: `Käyttäjähallinta`
    },
    teamLicense: {
        en: `License`,
        fi: `Lisenssi`
    },
    clear: {
        en: `Clear`,
        fi: `Tyhjennä`
    },
    of: {
        en: `of`,
        fi: `/`
    },
    inUse: {
        en: `in use`,
        fi: `käytössä`
    },
    chooseOperation: {
        en: `Choose operation`,
        fi: `Valitse toiminto`
    },
    name: {
        en: `Name`,
        fi: `Nimi`
    },
    role: {
        en: `Role`,
        fi: `Rooli`
    },
    radars: {
        en: `Radars`,
        fi: `Kartat`
    },
    // select radars view
    selectRadars: {
        en: `Select radars for:`,
        fi: `Valitse kartat käyttäjälle:`
    },
    radar: {
        en: `Radar`,
        fi: `Kartta`
    },
    lastUpdated: {
        en: `Updated`,
        fi: `Päivitetty`
    },
    // invite form
    inviteUsers: {
        en: `Invite users`,
        fi: `Kutsu käyttäjiä`
    },
    inviteCount: {
        en: count => `You can invite ${count} more user${count !== 1 ? 's' : ''}`,
        fi: count => `Käyttäjiä kutsuttavissa: ${count}`
    },
    radarCount: {
        en: count => `${count} radar${count !== 1 ? 's' : ''}`,
        fi: count => `${count} karttaa`
    },
    emailAddress: {
        en: `Email address`,
        fi: `Sähköposti`
    },
    addUser: {
        en: `ADD MORE`,
        fi: `LISÄÄ KÄYTTÄJIÄ`
    },
    // side menu
    layoutHeader: {
        en: `Radar layout`,
        fi: `Karttanäkymä`
    },
    editSectors: {
        en: `Edit sectors`,
        fi: `Muokkaa sektoreita`
    },
    editTimeranges: {
        en: `Edit time ranges`,
        fi: `Muokkaa aikajaksoja`
    },
    addPhenomena: {
        en: `Add content`,
        fi: `Lisää sisältöä`
    },
    settingsHeader: {
        en: `Settings`,
        fi: `Asetukset`
    },
    editTitle: {
        en: `Edit Title`,
        fi: `Muokkaa nimeä`
    },
    editBasicSettings: {
        en: `Edit basic settings`,
        fi: `Muokkaa perusasetuksia`
    },
    activateUsers: {
        en: `Collaboration toolbox`,
        fi: `Toiminnot`
    },
    conclusions: {
        en: `Conclusions`,
        fi: `Yhteenveto`
    },
    sendMessages: {
        en: `Send message`,
        fi: `Lähetä viestejä`
    },
    activateUsersHeader: {
        en: `Activate users`,
        fi: `Aktivoi käyttäjiä`
    },
    editConclusions: {
        en: `Edit conclusions`,
        fi: `Muokkaa yhteenvetoa`
    },
    managmentHeader: {
        en: `Radar management`,
        fi: `Karttojen hallinta`
    },
    cloneRadar: {
        en: `Copy radar`,
        fi: `Kopioi kartta`
    },
    deleteRadar: {
        en: `Delete radar`,
        fi: `Poista kartta`
    },
    deleteDoubleCheck: {
        en: `Are you sure you want to delete this radar?`,
        fi: `Haluatko varmasti poistaa tämän kartan?`
    },
    archiveDoubleCheck: {
        en: `This content will be removed from the search, but it will remain on the radars and other content elements to which it is linked. Are you sure you want to remove this content?`,
        fi: `Sisältö poistetaan hakukirjastosta, mutta se jää näkyviin niille kartoille ja sisältökorteille, joihin se on linkitetty. Haluatko varmasti poistaa tämän sisällön?`
    },
    // sector menu
    editName: {
        en: `Edit name & description`,
        fi: `Muokkaa nimeä ja kuvausta`
    },
    addSectorBefore: {
        en: `Add sector before`,
        fi: `Lisää sektori vasemmalle`
    },
    addSectorAfter: {
        en: `Add sector after`,
        fi: `Lisää sektori oikealle`
    },
    deleteSector: {
        en: `Delete sector`,
        fi: `Poista sektori`
    },
    // sector form
    editSectorTitle: {
        en: 'Sector title and content',
        fi: 'Sektorin nimi ja kuvaus'
    },
    sectorTitle: {
        en: 'Sector Title',
        fi: 'Sektorin nimi'
    },
    sectorDescription: {
        en: 'Sector description',
        fi: 'Sektorin kuvaus'
    },
    // timerange
    editTimerange: {
        en: `Edit timerange`,
        fi: `Muokkaa aikajaksoa`
    },
    addTimerange: {
        en: `Add new timerange`,
        fi: `Muokkaa aikajaksoa`
    },
    startYear: {
        en: `Start Year`,
        fi: `Alkaa`
    },
    endYear: {
        en: `End Year`,
        fi: `Päättyy`
    },
    timeRangeInfo: {
        en: `Time range info`,
        fi: `Aikajakson kuvaus`
    },
    // sandbox
    sandboxTitle: {
        en: `Add content to radar`,
        fi: `Lisää sisältö kartalle`
    },
    addToRadar: {
        en: `ADD TO RADAR`,
        fi: `LISÄÄ KARTALLE`
    },
    // list of phenomena
    choosePhenomenaLanguage: {
        en: 'Choose language:',
        fi: 'Valitse kieli'
    },
    preview: {
        en: `SHOW`,
        fi: `NÄYTÄ`
    },
    previewButton: {
        en: `PREVIEW`,
        fi: `ESIKATSELE`
    },
    filterByGroup: {
        en: 'Filter by group:',
        fi: 'Valitse ryhmä'
    },
    createNewLabel: {
        en: `Can't find what you're looking for?`,
        fi: `Etkö löydä etsimääsi?`
    },
    // createNew: {
    //     en: `CREATE A NEW PHENOMENON`,
    //     fi: `LUO UUSI ILMIÖ`
    // },
    // add phenomena form
    createPhenomenaFormTitle: {
        en: `Create/edit content`,
        fi: `Luo/muokkaa sisältöä`
    },
    createPhenomenaFormLanguageLabel: {
        en: `Content group and language`,
        fi: `Sisällön ryhmä ja kieli`
    },
    createPhenomenaFormLanguageDescription: {
        en: `Note, that Group and Language can not be changed after the content is saved`,
        fi: `Huomaa, että ryhmää ja kielivalintaa ei voi muuttaa tallentamisen jälkeen.`
    },
    group: {
        en: `Group`,
        fi: `Ryhmä`
    },
    language: {
        en: `Language`,
        fi: `Kieli`
    },
    createPhenomenaFormTitleAndLeadLabel: {
        en: `Title and content`,
        fi: `Otsikko ja sisältö`
    },
    createPhenomenaFormTitleAndLeadDescription: {
        en: `Give your content a brief and distinctive title. `,
        fi: `Anna sisällölle lyhyt ja erottuva nimi. Kirjoita lyhyt yhteenveto, jossa kuvaat keskeisen sisällön.`
    },
    createPhenomenaFormTitleLabel: {
        en: `Title`,
        fi: `Otsikko`
    },
    createPhenomenaFormTitleDescription: {
        en: `Try to use max 70 characters.`,
        fi: `Yritä käyttää alle 70 merkkiä.`
    },
    createPhenomenaFormShortTitleLabel: {
        en: `Short title`,
        fi: `Lyhyt otsikko`
    },
    createPhenomenaFormShortTitleDescription: {
        en: `A shortened title to the radar view. Try to use max 40 characters.`,
        fi: `Karttanäkymässä näytettävä lyhennetty nimi. Yritä käyttää alle 40 merkkiä.`
    },
    createPhenomenaFormLeadLabel: {
        en: `Summary`,
        fi: `Lyhyt yhteenveto`
    },
    createPhenomenaFormTypeLabel: {
        en: `Type`,
        fi: `Tyyppi`
    },
    media: {
        en: `Main video / image`,
        fi: `Päävideo tai -kuva`
    },
    video: {
        en: `Embed video`,
        fi: `Liitä video`
    },
    videoFormatsText: {
        en: `You can embed a video to your content. Please use the following embedding formats:`,
        fi: `Voit upottaa sisältökorttiin videon. Kirjoita yllä olevaan kenttään linkin alkuosa (esim. https://www.youtube.com/embed/) ja lisää heti sen perään valitsemasi videon ID-numero. Tässä esimerkit:`
    },
    youtubeFormat: {
        en: `- For YouTube videos: https://www.youtube.com/embed/SLAFCVeV6KI`,
        fi: `- YouTube-videot: https://www.youtube.com/embed/SLAFCVeV6KI`
    },
    vimeoFormat: {
        en: `- For Vimeo videos: https://player.vimeo.com/video/146910641`,
        fi: `- Vimeo-videot: https://player.vimeo.com/video/146910641`
    },
    image: {
        en: `Embed Image`,
        fi: `Liitä kuva`
    },
    imageUploadDescription: {
        en: `Please use at least a 600 px wide image. Files must be less than 2 MB. Accepted file types: jpg jpeg png gif. Please remember to check that you have the right to publish the image.`,
        fi: `Käytä vähintään 600 px leveää kuvaa. Kuvan koko saa olla enintään 2 Mt. Hyväksytyt tiedostotyypit: jpg jpeg png gif. Muista varmistaa, että sinulla on oikeus julkaista kyseinen kuva.`
    },
    createPhenomenaFormVideoLabel: {
        en: `Video/Image description`,
        fi: `Video-/kuvateksti`
    },
    createPhenomenaFormVideoDescription: {
        en: `Remember to show here the source / copyright info.`,
        fi: `Muista liittää tieto lähteestä tai tekijästä (copyright).`
    },
    createPhenomenaFormMainContentLabel: {
        en: `Main content`,
        fi: `Leipäteksti ja lisätiedot`
    },
    relatedPhenomena: {
        en: `Related content`,
        fi: `Liittyvät sisällöt`
    },
    relatedPhenomenaText: {
        en: `You can link other content to this one`,
        fi: `Voit linkittää muita sisältöjä tähän sisältökorttiin.`
    },
    // create radar form
    headerTitle: {
        en: `Radar Header and User Group`,
        fi: `Kartan nimi ja käyttäjäryhmä`
    },
    header: {
        en: `Radar header`,
        fi: `Kartan nimi`
    },
    groupAvailabilityText: {
        en: `The group of users your radar will be available to:`,
        fi: `Käyttäjäryhmä, jonka käyttöön kartta tulee:`
    },
    groupAvailability: {
        en: `Your radar will be available to users in group:`,
        fi: `Kartta näkyy ryhmälle:`
    },
    languageAvailability: {
        en: `The language of a radar can not be changed later.`,
        fi: `Kartan kieltä ei voi vaihtaa myöhemmin.`
    },
    basicSettings: {
        en: `Basic Settings`,
        fi: `Perusasetukset`
    },
    selectPhenomenaSet: {
        en: `Select content set`,
        fi: `Valitse esitäytetty sisältövalikoima`
    },
    selectRadarImage: {
        en: `Select radar image`,
        fi: `Syötä kartan tunnuskuva`
    },
    selectRadarTitleImage: {
        en: `Select radar (left) and radar title (right) images`,
        fi: `Syötä kartan tunnuskuva`
    },
    noImageSelected: {
        en: `No image selected`,
        fi: `Kuvaa ei ole valittuna`
    },
    radarImageText: {
        en: `Radar image is shown on the radar icon in the center of your radar. Supported file types: jpg, jpeg, png (max. 1 Mb). Please note that the image significantly crops to fit inside the circle, so there should be wide margins around the logo.`,
        fi: `Kartan tunnuskuva tulee sen keskipisteeseen. Tuetut tiedostomuodot: jpg, jpeg, png (max. 1 Mb). Kuva skaalataan keskipisteeseen lyhyemmän sivun mukaisesti eli varaa kuvaan riittävästi marginaaleja.`
    },
    hideUserList: {
        en: `User list visibility`,
        fi: `Käyttäjälistan näkyvyys`
    },
    hideUserListLabel: {
        en: `Hide the user list from users`,
        fi: `Piilota käyttäjälista käyttäjiltä`
    },
    phenomena: {
        en: `Content`,
        fi: `Sisältö`
    },
    owner: {
        en: `Owner`,
        fi: `Omistaja`
    },
    createNew: {
        en: `CREATE NEW`,
        fi: `LUO UUSI`
    },
    title: {
        en: `Title`,
        fi: `Otsikko`
    },
    edit: {
        en: `Edit`,
        fi: `Muokkaa`
    },
    clone: {
        en: `Copy`,
        fi: `Kopioi`
    },
    view: {
        en: `View`,
        fi: `Näytä`
    },
    searchByKeywords: {
        en: `Search by keywords`,
        fi: `Etsi hakusanoilla`
    },
    // error
    error: {
        en: 'Oops! Something went wrong',
        fi: `Hups! Jokin meni pieleen`
    },
    voting: {
        en: `Voting`,
        fi: `Äänestys`
    },
    upvotesForHalo: {
        en: `Upvotes required for halo`,
        fi: `Sädekehään vaadittava äänimäärä`
    },
    createFormVotingDescription: {
        en: `Allow users to vote on Content cards (up and down arrows).`,
        fi: `Käyttäjät voivat äänestää sisältö (nuolet ylös/alas)`
    },
    arrows: {
        en: `Arrows`,
        fi: `Nuolet`
    },
    up: {
        en: `Up`,
        fi: `Ylös`
    },
    upDown: {
        en: `Up & Down`,
        fi: `Ylös & Alas`
    },
    rating: {
        en: `Rating`,
        fi: `Arviointi`
    },
    createFormRatingDescription: {
        en: `Allow users to rate on Content cards on two axis.`,
        fi: `Käyttäjät voivat arvioida sisältöä`
    },
    horizontalAxis: {
        en: `Horizontal axis`,
        fi: `Vaaka-akseli`
    },
    verticalAxis: {
        en: `Vertical axis`,
        fi: `Pystyakseli`
    },
    axisName: {
        en: `Axis name`,
        fi: `Akselin nimi`
    },
    leftEnd: {
        en: `Left end`,
        fi: `Vasen`
    },
    rightEnd: {
        en: `Right end`,
        fi: `Oikea`
    },
    lowEnd: {
        en: `Low end`,
        fi: `Ala`
    },
    highEnd: {
        en: `High end`,
        fi: `Ylä`
    },
    cornersText: {
        en: `Table cells (optional)`,
        fi: `Nelikentän osien nimeäminen`
    },
    topLeft: {
        en: `Top left`,
        fi: `Vasen ylä`
    },
    bottomLeft: {
        en: `Bottom left`,
        fi: `Vasen ala`
    },
    topRight: {
        en: `Top right`,
        fi: `Oikea ylä`
    },
    bottomRight: {
        en: `Bottom right`,
        fi: `Oikea ala`
    },
    commenting: {
        en: `Comments`,
        fi: `Kommentointi`
    },
    createFormCommentingDescription: {
        en: `Allow users to add comments on Content cards on Opportunities, Threats and Actions.`,
        fi: `Käyttäjät voivat kommentoida sisältöä`
    },
    allowLikeCommenting: {
        en: `Allow users to like the other users’ comments on Content cards.`,
        fi: `Salli käyttäjien tykätä toistensa kommenteista`
    },
    commentTopics: {
        en: `Comments`,
        fi: `Kommentit`
    },
    discussion: {
        en: `Discussion area`,
        fi: `Keskustelu`
    },
    // buttons
    done: {
        en: `DONE`,
        fi: `DONE`
    },
    confirm: {
        en: `CONFIRM`,
        fi: `CONFIRM`
    },
    cancel: {
        en: `CANCEL`,
        fi: `PERUUTA`
    },
    update: {
        en: `UPDATE`,
        fi: `PÄIVITÄ`
    },
    create: {
        en: `CREATE`,
        fi: `LUO`
    },
    back: {
        en: `BACK`,
        fi: `TAKAISIN`
    },
    save: {
        en: `SAVE`,
        fi: `TALLENNA`
    },
    next: {
        en: `NEXT`,
        fi: `SEURAAVA`
    },
    select: {
        en: `SELECT`,
        fi: `VALITSE`
    },
    delete: {
        en: `REMOVE`,
        fi: `POISTA`
    },
    close: {
        en: `CLOSE`,
        fi: `SULJE`
    },
    archive: {
        en: `ARCHIVE`,
        fi: `ARKISTO`
    },
    sendInvite: {
        en: `SEND INVITATION`,
        fi: `LÄHETÄ KUTSU`
    },
    // dropdown options
    english: {
        en: `English`,
        fi: `Englanti`
    },
    finnish: {
        en: `Finnish`,
        fi: `Suomi`
    },
    all: {
        en: `All`,
        fi: `Kaikki`
    },
    // deprecated?
    strengthening: {
        en: `Strengthening`,
        fi: `Vahvistuva`
    },
    rising: {
        en: `Strengthening`,
        fi: `Vahvistuva`
    },
    // deprecated?
    weakening: {
        en: `Weakening`,
        fi: `Heikkenevä`
    },
    cooling: {
        en: `Weakening`,
        fi: `Heikkenevä`
    },
    wildcard: {
        en: `Wild card`,
        fi: `Villi kortti`
    },
    established: {
        en: `Established`,
        fi: `Vakiintunut`
    },
    undefined: {
        en: `(no type)`,
        fi: `(ei tyyppiä)`
    },
    weaksignal: {
        en: `Weak signal`,
        fi: `Heikko signaali`
    },
    signal: {
        en: `Signal`,
        fi: `Signaali`
    },
    summary: {
        en: `Summary`,
        fi: `Yhteenveto`
    },
    public: {
        en: `Public content`,
        fi: `Julkiset sisältö`
    },
    groupMissing: {
        en: `Please select a group`,
        fi: `Valitse ryhmä`
    },
    languageMissing: {
        en: `Please select a language`,
        fi: `Valitse kieli`
    },
    titleMissing: {
        en: `Title is required`,
        fi: `Otsikko on pakollinen tieto`
    },
    missingRequiredPhenomenonData: {
        en: `Please make sure you have filled in all required fields (language, group and title)`,
        fi: `Varmista, että olet syöttänyt tiedot kaikkiin pakollisiin kenttiin (kieli, ryhmä ja otsikko)`,
    },
    feed: {
        en: `Tags`,
        fi: `Tunnisteet`
    },
    'radar-error-radarName': {
        en: `Radar header is required`,
        fi: `Kartan nimi on pakollinen tieto`
    },
    'radar-error-group': {
        en: `The group has reached the maximum number of radars`,
        fi: `Ryhmälle ei voi lisätä enempää karttoja`
    },
    clonedRadarSuccess: {
        en: `Copied!`,
        fi: `Kopiointi valmis!`
    },
    clonedRadarSuccessDescription: {
        en: `A copy of your radar has been created.`,
        fi: `Olemme luoneet kopion kartastasi.`
    },
    clonedContinueWithCurrent: {
        en: `Continue with this radar`,
        fi: `Jatka nykyisellä kartalla`
    },
    clonedGoToCreated: {
        en: `Go to the copied radar`,
        fi: `Siirry kopioon`
    },
    deletePhenomenaDoubleCheck: {
        en: `Are you sure you want to remove the content from the radar?`,
        fi: `Haluatko varmasti poistaa sisältö kartalta?`
    },
    askOwnerForMoreLicenses: {
        en: `Please note that you have reached the maximum amount of users attached to your subscription plan. Please ask the owner of this group to upgrade the account for more users.`,
        fi: `Ryhmään ei tällä hetkellä mahdu enempää käyttäjiä. Voitte pyytää lisenssinne haltijaa (rooli: ‘Omistaja’) tilaamaan ryhmällenne lisää käyttäjätilejä.`
    },
    getMoreLicenses: {
        en: `Please note that you have reached the maximum amount of users attached to your subscription plan. In case you need more, send us a message and we will contact you shortly.`,
        fi: `Ryhmään ei tällä hetkellä mahdu enempää käyttäjiä. Mikäli tarvitset lisää käyttäjätilejä, lähetäthän meille viestin, niin olemme sinuun pian yhteydessä`
    },
    getMoreLicensesButton: {
        en: `Send us a message`,
        fi: `Lähetä meille viesti`
    },
    listOfSignals: {
        en: `List`,
        fi: `Luettelo`
    },
    addNewSignal: {
        en: `Add a new`,
        fi: `Lisää uusi`,
    },
    mainContent: {
        en: `Main content`,
        fi: `Lyhyt kuvaus`,
    },
    createdBy: {
        en: `Created by`,
        fi: `Luonut`,
    },
    noSignalsCreated: {
        en: `There are no results yet. Be the first to create!`,
        fi: `Ei hakutuloksia - luo uusi!`,
    },
    creator: {
        en: `Radar's creator`,
        fi: `Radarin luoja`,
    },
    newsFeed: {
        en: `News feed`,
        fi: `Uutisvirrat`,
    },
    feedDescription: {
        en: `You can attach a news feed to your content using the following format: https://international-example-of-rss-feed Please note, that the link has to be a secured one starting with ‘https’.`,
        fi: `Voit liittää sisältösi haluamasi uutisvirran syöttämällä sen osoitteen seuraavassa muodossa: https://international-example-of-rss-feed Huomaa, että linkin tulee olla turvallinen eli sen alussa on oltava ‘https’.`
    },
    feedUrl: {
        en: `Feed url`,
        fi: `Uutisvirran osoite`
    },
    addFeed: {
        en: `add feed`,
        fi: `LISÄÄ`
    },
    addedFeeds: {
        en: `Embedded feeds`,
        fi: `Linkitetyt uutisvirrat`
    },
    noFeeds: {
        en: `No feeds have been added yet`,
        fi: `Ei linkitettyjä uutisvirtoja`
    },
    fieldMissing: {
        en: `Value missing. This is a required field.`,
        fi: `Pakollinen kenttä.`
    },
    filterPhenomena: {
        en: `Filter content`,
        fi: `Suodata sisältö`
    },
    noResults: {
        en: `No results`,
        fi: `Ei tuloksia`
    },
    missingRequiredSignalData: {
        en: `Please make sure you have filled in all required fields (title and content)`,
        fi: `Varmista, että olet syöttänyt tiedot kaikkiin pakollisiin kenttiin`,
    },
    newsFeedError: {
        en: `Please enter a valid value.`,
        fi: `Syötä kelvollinen arvo.`
    },
    linksError: {
        en: `Please enter a valid link.`,
        fi: `Syötä kelvollinen linkki.`
    },
    newsFeedCreationError: {
        en: `There was a problem adding your news feed.`,
        fi: `Uutisyötteen lisääminen epäonnistui.`
    },
    newsFeedFetchError: {
        en: `There was a problem fetching your news feeds.`,
        fi: `Uutissyötteen haku epäonnistui.`
    },
    newsFeedUpdateError: {
        en: `Your content information has been updated, but there was a problem updating your news feed.`,
        fi: `Sisältö on tallennettu, mutta kaikkien uutissyötteiden lisääminen ei onnistunut.`
    },
    publicWord: {
        en: `FP phenomena`,
        fi: `FP muutosilmiöt`
    },
    allWord: {
        en: `All`,
        fi: `Kaikki`
    },
    someNewsFeedCreationError: {
        en: list => `Failed to add the following news feeds: ${list.map(text => text + ',')}`,
        fi: list => `Seuraavien uutissyötteiden lisäys epäonnistui: ${list.map(text => text + ',')}`
    },
     shareRadar: {
        en: `Share radar`,
        fi: `Jaa kartta`
    },
    copyToClipboard: {
        en: `Copy to clipboard`,
        fi: `Kopioi leikepöydälle`
    },
    copyUrl: {
        en: `Copy url`,
        fi: `Kopioi linkki`
    },
    enableSharing: {
        en: `Enable sharing`,
        fi: `Salli jakaminen`
    },
    expirationDate: {
        en: `Expiration date`,
        fi: `Päättymispäivä`
    },
    sharingDescription: {
        en: `Enable sharing, set the expiration date and press 'Share' to create an URL for your radar. Users with the URL can access your radar.`,
        fi: `Salli jakaminen, aseta päättymispäivä ja valitse "Jaa kartta" luodaksesi linkin kartallesi. Linkin kautta haluamasi henkilöt pääsevät kartalle.`
    },
    chooseDate: {
        en: `Choose date`,
        fi: `Valitse päivä`
    },
    shareUrlAvailability: {
        en: `The url will be generated once radar sharing is enabled`,
        fi: `Linkki luodaan, kun jakaminen on sallittu`
    },
    listUploadSuccess: {
        en: `List uploaded successfully`,
        fi: `Listan päivitys onnistui`
    },
    inviteInfo: {
        en: `If you want to add several email addresses at the same time, you can use commas (,) to seperate users from each other, or you can upload a CSV file that contains the email addresses.`,
        fi: `Jos haluat lisätä useampia käyttäjiä  samalla kertaa, erottele sähköpostiosoitteet pilkulla tai syötä sähköpostiosoitteet sisältävä CSV-tiedosto.`
    },
    send: {
        en: `Send`,
        fi: `Lähetä`
    },
    continue: {
        en: `Continue`,
        fi: `Jatka`
    },
    personalizeInvitation: {
        en: `Write your invitation`,
        fi: `Kirjoita saatesanat kutsuusi`
    },
    personalizeInvitationInfo: {
        en: `The recipients will get instructions how to login to the platform by email from hello@futuresplatform.com. Below you can modify the message part of that email, for example you can write your personal instructions to the Message field.`,
        fi: `Kutsumillesi henkilöille lähetetään ohje palveluun kirjautumiseen sähköpostilla osoitteesta hello@futuresplatform.com. Alla voit halutessasi muokata sähköpostin sisältämää viestiosiota kirjoittamalla omat terveisesi Viestit-kenttään.`
    },
    subject: {
        en: `Subject`,
        fi: `Aihe`
    },
    message: {
        en: `Message`,
        fi: `Viesti`
    },
    inviteEmailDefaultSubject: {
        en: `You have been given access to Futures Platform`,
        fi: `Sinut on kutsuttu käyttämään Futures Platformia`
    },
    inviteEmailDefaultMessage: {
        en: `Hi, I am excited to start collaboration with you on Futures Platform. Feel free to contact me if you have any questions!`,
        fi: `Hei, odotan innolla yhteistyötämme Futures Platformilla. Olethan yhteydessä minuun, mikäli sinulla on kysymyksiä!`
    },
    visitor: {
        en: `Visitor`,
        fi: `Vierailija`
    },
    csvUploadErr: {
        en: `Oops, there was some problem uploading your csv file, please make sure the file is in correct format and that all fields contain a valid email address`,
        fi: `Ups, CSV-tiedoston lataamisessa oli jokin ongelma, onko tiedosto varmasti .csv-muodossa`
    },
    outDatedVersionError: {
        en: `Oops, it seems your radar's content are out of date. We'll refetch them for you so you can try again`,
        fi: `Ups, vaikuttaa siltä, että karttasi sisältöä ovat muuttuneet muualla. Päivitämme kartan, jotta voit yrittää uudelleen.`
    },
    phenomenaNotFound: {
        en: `Oops, we couldn't find your content. We'll update your radar to the newest version`,
        fi: `Ups, sisältöä ei löytynyt. Karttasi päivitetään automaattisesti uusimpaan versioon.`
    },
    phenomenaExists: {
        en: `Oops, it seems this content already exists. We'll update your radar to the newest version`,
        fi: `Ups, sisältö on jo lisätty kartalle. Karttasi päivitetään automaattisesti uusimpaan versioon.`
    },
    phenomenaInvalid: {
        en: `Oops, it seems we can't do that. We'll update your radar to the newest version`,
        fi: `Ups, toiminto ei onnistunut. Karttasi päivitetään automaattisesti uusimpaan versioon.`
    },
    radarUpdated: {
        en: `The radar has been edited by another editor`,
        fi: `Toinen käyttäjä on muokannut karttaa`
    },
    hideVisitors: {
        en: `hide visitors`,
        fi: `piilota vierailijat`
    },
    showOnlyVisitors: {
        en: `only show visitors`,
        fi: `näytä vain vierailijat`
    },
    allRadars: {
      en: `All radars`,
      fi: `Kaikki kartat`
    },
    email: {
      en: `Email`,
      fi: `Email`
    },
    removeUser: {
      en: `Remove user from group`,
      fi: `Poista käyttäjä ryhmästä`
    },
    userDeleteConfirmation: {
      en: `Are you sure you want to remove this user or users ?`,
      fi: `Oletko varma, että haluat poistaa käyttäjän?`
    },
    expires: {
      en: `Expires`,
      fi: `Vanhenee`
    },
    numberOfVisits: {
      en: `Number of visits`,
      fi: `Vierailujen määrä`
    },
    indefinite: {
      en: `Never`,
      fi: `Ei koskaan`
    },
    personalUrl: {
      en: `Personal radar URL:`,
      fi: `Henkilökohtainen kartan URL:`
    },
    radarShareNote: {
      en: `NOTE! If you want to give this user access to more radars, please send an invitation to the user.`,
      fi: `Huom! Jos haluat antaa käyttäjälle pääsyn muihin karttoihin, lähetä kutsu käyttäjälle.`
    },
    regenerateUrl: {
      en: `REGENERATE URL`,
      fi: `Luo uusi URL`
    },
    regenerateUrlNote: {
      en: `When you regenerate the URL, the user will be sent the new URL by mail automatically.`,
      fi: `Luodessasi uuden URL:n käyttäjälle lähetetään uusi URL automaattisesti.`
    },
    shareRegenerateConfirmation: {
      en: `Are you sure you want to regenerate this share?`,
      fi: `Oletko varma, että haluat luoda uuden jaon?`
    },
    regenerate: {
      en: `regenerate`,
      fi: `luo uusi`
    },
    shareRadarFromUsrMngmt: {
        en: `You can invite users to this radar from the User management, or create a Shared collaboration link (public link) and share it in your network.`,
        fi: `Voit kutsua kollegasi kartalle käyttäjähallinnasta tai tehdä julkisen linkin ja jakaa sen verkostossasi.`
    },
    shareRadarWithoutPublicLink: {
        en: `You can invite users to this radar from the User management.`,
        fi: `Voit kutsua kollegasi kartalle käyttäjähallinnasta.`
    },
    goToManagement: {
        en: `Open user management`,
        fi: `Avaa käyttäjähallinta`
    },
    csvFileFormatTitle: {
        en: `CSV file format`,
        fi: `CSV-tiedostomuoto`
    },
    csvFileFormat: {
        en: `The first row must be Email and then email addresses must be in a separate rows.`,
        fi: `Ensimmäisellä rivillä on luettava Email, jonka jälkeen sähköpostiosoitteet on oltava omilla riveillään.`
    },
    csvFileExampleTitle: {
        en: `CSV example:`,
        fi: `CSV-esimerkki:`
    },
    authorizingError: {
        en: `authorizing`,
        fi: `kirjauduttaessa`
    },
    fetchingPhenomenaError: {
        en: `fetching content`,
        fi: `ladattaessa sisältöä`
    },
    fetchingPhenomenaTypesError: {
        en: `fetching content types`,
        fi: `ladattaessa sisältötyyppejä`
    },
    fetchingRadarError: {
        en: `fetching your radar`,
        fi: `ladattaessa karttaasi`
    },
    refetchingPhenomenaError: {
        en: `refetching your content`,
        fi: `ladattaessa uudelleen sisältösi`
    },
    deletingPhenomenaError: {
        en: `with deleting your content`,
        fi: `poistettaessa sisältösi`
    },
    updatingPhenomenaError: {
        en: `with updating your content`,
        fi: `päivitettäessä sisältösi`
    },
    creatingPhenomenaError: {
        en: `with creating your content`,
        fi: `luotaessa sisältöä`
    },
    settingPhenomenaError: {
        en: `with setting the content position`,
        fi: `asetettaessa sisältöä kartalle`
    },
    cloningRadarError: {
        en: `cloning radar`,
        fi: `kopioitaessa karttaa`
    },
    licenseError: {
        en: `There was an error, it seems you dont have a sufficient amount of radars in your licence`,
        fi: `Tapahtui virhe. Vaikuttaa siltä, lisenssisi karttamäärä on tullut täytettn.`
    },
    deletingRadarError: {
        en: `deleting radar`,
        fi: `poistettaessa karttaa`
    },
    fetchingRSSError: {
        en: `fetching RSS feed`,
        fi: `noudettaessa RSS-syötettä`
    },
    fetchingGroupsError: {
        en: `fetching user groups`,
        fi: `noudettaessa käyttäjän ryhmiä`
    },
    creatingRadarError: {
        en: `creating your radar`,
        fi: `luotaessa karttaasi`
    },
    updatingRadarError: {
        en: `updating your radar`,
        fi: `päivitettäessä karttaasi`
    },
    fetchingSetsError: {
        en: `fetching radar sets`,
        fi: `ladattaessa karttoja`
    },
    addingSectorError: {
        en: `adding your sector`,
        fi: `lisättäessä sektoria`
    },
    editingSectorError: {
        en: `with editing your sector information`,
        fi: `sektorin tietoja muokattaessa`
    },
    deletingSectorError: {
        en: `deleting your sector`,
        fi: `poistettaessa sektoriasi`
    },
    fetchingSignalsError: {
        en: `fetching signals`,
        fi: `ladattaessa signaaleja`
    },
    creatingSignalsError: {
        en: `with creating your signal`,
        fi: `signaalia luotaessa`
    },
    updatingTimelinesError: {
        en: `with updating your timerange`,
        fi: `ajanjaksoa päivittäessä`
    },
    validTimerangeError: {
        en: `Please enter a valid year relative to the timerange`,
        fi: `Syötä sopiva vuosi suhteessa ajanjaksoon`
    },
    groupNameError: {
        en: `changing group name`,
        fi: `muutettaessa ryhmän nimeä`
    },
    fetchingRadarsError: {
        en: `fetching radars`,
        fi: `ladattaessa karttoja`
    },
    changingRoleError: {
        en: `changing user role`,
        fi: `muutettaessa käyttäjän roolia`
    },
    verifyLicenseError: {
        en: `verifying license`,
        fi: `tarkistettaessa lisenssiä`
    },
    fetchingUsersError: {
        en: `fetching users`,
        fi: `ladattaessa käyttäjiä`
    },
    fetchingSharedRadarsError: {
        en: `fetching shared radars`,
        fi: `ladattaessa jaettuja karttoja`
    },
    regeneratingShareError: {
        en: `regenerating share`,
        fi: `luotaessa uutta jakoa`
    },
    deletingUsersError: {
        en: `deleting user(s)`,
        fi: `poistettaessa käyttäjiä`
    },
    groupURLError: {
        en: `No group parameter found in URL; please provide a group identifier and try again`,
        fi: `Ryhmä puuttuu URL:sta; lisää ryhmän tunniste ja yritä uudelleen.`
    },
    changingUserError: {
        en: `changing user radars`,
        fi: `muokattessa käyttäjän karttoja`
    },
    sendingInvitesError: {
        en: `sending invitations`,
        fi: `lähetettäessä kutsuja`
    },
    infoUrl: {
        en: `https://info.futuresplatform.com/hub`,
        fi: `https://go2.futuresplatform.com/node/12006`
    },
    filterByRole: {
        en: `Filter by role:`,
        fi: `Suodata roolin mukaan:`
    },
    allRoles: {
        en: `All roles`,
        fi: `Kaikki roolit`
    },
    searchByEmail: {
        en: `Search by email`,
        fi: `Etsi sähköpostiosoitteella`
    },
    allGroupsFilter: {
        en: `All groups`,
        fi: `Kaikki ryhmät`
    },
    publicFilter: {
        en: `Public`,
        fi: `Julkinen`
    },
    timing: {
        en: `Timing`,
        fi: `Ajoitus`
    },
    estimatedTimeRange: {
        en: `Estimated time range:`,
        fi: `Arvioitu aikajakso:`
    },
    shortTerm: {
        en: `SHORT-TERM`,
        fi: `LYHYT`
    },
    midTerm: {
        en: `MID-TERM`,
        fi: `KESKIPITKÄ`
    },
    longTerm: {
        en: `LONG-TERM`,
        fi: `PITKÄ`
    },
    laterTerm: {
        en: `LATER`,
        fi: `MYÖHEMMIN`
    },
    years: {
        en: `years`,
        fi: `vuotta`
    },
    timestamp: {
        en: `Timestamp`,
        fi: `Aikaleima`
    },
    crowdSourced: {
        en: `crowdsourced: `,
        fi: `joukkoistettu: `
    },
    phenomenaLinks: {
       en:  'Links to webpages',
       fi: 'Linkit verkkosivuille'
    },
    linksLabels: {
        en:  'Add links',
        fi: 'Lisää linkkejä'
    },
    contentExplorer: {
        en: 'Content explorer',
        fi: 'Sisältöhaku'
    },
    authorTimerange: {
        en: 'Time range estimated by author',
        fi: 'Kirjoittajan arvio aikajaksoksi'
    },
    crowdTimerange: {
        en: 'Crowdsourced median',
        fi: 'Joukkoistettu mediaani'
    },
    searchFilters: {
        en: 'Search filters',
        fi: 'Hakuehdot'
    },
    resetFilters: {
        en: `Reset filters`,
        fi: `Nollaa hakuehdot`
    },
    resetTypes: {
        en: `Reset types`,
        fi: `Nollaa tyypit`
    },
    time: {
        en: `Time`,
        fi: `Aika`
    },
    groupTags: {
        en: `Group tags`,
        fi: `Ryhmän tagit`
    },
    tags: {
        en: `Tags`,
        fi: `Tagit`
    },
    tag: {
        en: `Tag`,
        fi: `Tagi`
    },
    none: {
        en: `None`,
        fi: `Ei valittu`
    },
    fpTags: {
        en: `FP tags`,
        fi: `FP tagit`
    },
    loading: {
        en: `Loading...`,
        fi: `Lataa...`
    },
    tagLoadingError: {
        en: `There was an error loading tags, please try again later`,
        fi: `Tagien lataus ei onnistunut, yritä hetken kuluttua uudestaan`
    },
    addingPhenomenaTagError: {
        en: `tagging your content`,
        fi: `tagien liittäminen sisältöön`
    },
    removingPhenomenaTagError: {
        en: `removing a tag from your content`,
        fi: `tagin poistaminen sisällöstä`
    },
    from: {
        en: `From`,
        fi: `Mistä`
    },
    to: {
        en: `To`,
        fi: `Mihin`
    },
    noTimingSelected: {
        en: `: no timing selected`,
        fi: `:  Ajoitusta ei ole tehty`
    },
    mediaUploaded: {
        en: `: Yes`,
        fi: `On`
    },
    noMediaUploaded: {
        en: `: No`,
        fi: `: Ei ole`
    },
    linksUploaded: {
        en: `: Yes`,
        fi: `: On`
    },
    noLinksUploaded: {
        en: `: No`,
        fi: `: Ei ole`
    },
    newsFeedsUploaded: {
        en: `: Yes`,
        fi: `: On`
    },
    noNewsFeedsUploaded: {
        en: `: No`,
        fi: `: Ei ole`
    },
    hasRelatedPhenomena: {
        en: `: Yes`,
        fi: `: On`
    },
    hasNoRelatedPhenomena: {
        en: `: No`,
        fi: `: Ei ole`
    },
    hasFeedTags: {
        en: `: Yes`,
        fi: `: On`
    },
    hasNoFeedTags: {
        en: `: No`,
        fi: `: Ei ole`
    },
    addNewPhenomena: {
        en: `+ CREATE NEW`,
        fi: `+ LUO UUSI`
    },
    keywords: {
        en: `keywords`,
        fi: `avainsanat`
    },
    concept: {
        en: `context`,
        fi: `karttapohja`
    },
    wizardKeywordsLabelText: {
        en: `Type in keywords`,
        fi: `Kirjoita avainsanat`
    },
    wizardConceptLabelText: {
        en: `Select a context`,
        fi: `Valitse karttapohja`
    },
    wizardTitleLabelText: {
        en: `Name it`,
        fi: `Anna nimi`
    },
    creationWizardSearchPlaceholder: {
        en: `For example: "Biomass production in the Asian market"`,
        fi: `Esimerkiksi: "Biomassan tuotanto Aasian markkinoilla`
    },
    wizardReccomendationsTitle: {
        en: `Futurists' recommendations based on your search terms:` ,
        fi: `Futuristiemme suositukset syöttämiesi hakusanojen perusteella:`
    },
    sectors: {
        en: `Radar includes sectors`,
        fi: `Kartta koostuu sektoreista`
    },
    creationWizardTitlePlaceholder: {
        en: `Type the title of the radar (max 50 characters)`,
        fi: `Kirjoita kartan nimi tähän (max 50 merkkiä)`
    },
    nameYourRadar: {
        en: `Give your radar a short name`,
        fi: `Anna kartallesi lyhyt nimi`
    },
    createAnother: {
        en: `Create another`,
        fi: `Luo uusi`
    },
    openTheRadar: {
        en: `Open the radar`,
        fi: `Avaa kartta`
    },
    congrats: {
        en: `Congratulations!`,
        fi: `Onnittelut!`
    },
    createdRadarTitle: {
        en: `Your radar is now switched on`,
        fi: `Karttasi on nyt aktivoitu`
    },
    createdRadarLabelOne: {
        en: `You can start exploring it right away.<br /> You can also modify it, and share it with your colleagues`,
        fi: `Voit tutustua siihen saman tien.<br /> Voit myös muokata sitä ja jakaa sen kollegojesi kanssa`
    },
    createdRadarLabelTwo: {
        en: `In <b><u><a href="https://info.futuresplatform.com/hub" target="_blank">the HUB</a></u></b> you can always find inspirational content and videos how others have used their radars.`,
        fi: `<b><u><a href="https://info.futuresplatform.com/hub" target="_blank">HUBista</a></u></b> löydät paljon inspiroivaa sisältöä ja videoita.`
    },
    previewInHub: {
        en: `You can learn more about the prefilled radars at <b><u><a href="https://info.futuresplatform.com/hub" target="_blank">the HUB</a></u></b>`,
        fi: `<b><u><a href="https://info.futuresplatform.com/hub" target="_blank">HUBissa</a></u></b> voit myös selata muita mahdollisia karttapohjia.`
    },
    templatePreview: {
        en: `RADAR PREVIEW`,
        fi: `ESIKATSELU`
    },
    resultsFound: {
        en: `page(s) of results found`,
        fi: `sivu(a) tuloksia`
    },
    closeFilters: {
        en: `Close filters`,
        fi: `vahvista`
    },
    groupAndLanguageSelectionTitle: {
        en: `Please select`,
        fi: `Valitse asetukset`
    },
    prefilledContent: {
        en: `Prefilled content`,
        fi: `Esitäytetty sisältö`
    },
    prefilled: {
        en: `Prefilled`,
        fi: `Esitäytetty`
    },
    empty: {
        en: `Empty`,
        fi: `Tyhjä`
    },
    setup: {
        en: `Setup`,
        fi: `Perusasetukset`
    },
    wizardSetupLabelText: {
        en: `Set the basics`,
        fi: `Valitse asetukset`
    },
    noPreviewAvailable: {
        en: `No preview image available`,
        fi: `No preview image available`
    },
    deleteAllVotesNote: {
        en: `NOTE! Are you sure you want to delete permanently all votings for this map?`,
        fi: `HUOMAUTUS! Haluatko varmasti poistaa kaikki tämän kartan äänestykset pysyvästi?`
    },
    deleteAllRatesNote: {
        en: `NOTE! Are you sure you want to delete permanently all ratings for this map?`,
        fi: `HUOMAUTUS! Haluatko varmasti poistaa kaikki tämän kartan arviot pysyvästi?`
    },
    publicLink: {
        en: `CREATE A PUBLIC LINK`,
        fi: `NÄYTÄ JAETTAVA LINKKI`
    },
    createPublicLink: {
        en: `Create a Shared Collaboration Link`,
        fi: `Luo jaettu yhteistyölinkki`
    },
    publicLinkNote: {
        en: `Copy the link and share it in your network. Anyone with the link can access this radar`,
        fi: `Kopioi linkki ja jaa se verkostossasi. Otathan huomioon, että linkkiä klikkaamalla kuka tahansa pääsee tälle kartalle.`
    },
    regeneratePublicLink: {
        en: `REGENERATE LINK`,
        fi: `LUO UUSI LINKKI`
    },
    publicLinkURL: {
        en: `Shared Collaboration Link: `,
        fi: `Jaettu yhteistyölinkki:`
    },
    regeneratePublicLinkNote: {
        en: `NOTE! Regenerating the URL will deactivate the previous link`,
        fi: `HUOM. Uuden linkin luonti poistaa nykyisen linkin toiminnasta.`
    },
    deletePublicLink: {
        en: `Delete the public link`,
        fi: `Poista julkinen linkki`
    },
    sharePublicLinkConfirmation: {
        en: `Are you sure you want to make a new public link?`,
        fi: `Oletko varma, että haluat tehdä uuden linkin?`
    },
    sharePublicLinkConfirmationNote: {
        en: `The old link will stop working when you create a new one.`,
        fi: `Vanha linkki lakkaa toimimasta, kun luot uuden.`
    },
    deletePublicLinkConfirmation: {
        en: `Are you sure you want to remove this public link?`,
        fi: `Haluatko varmasti poistaa tämän julkisen linkin?`,        
    },
    customTypes: {
        en: `Custom types`,
        fi: `Ryhmäkohtaiset`,   
    },
    fpTypes: {
        en: `FP types`,
        fi: `FP-ilmiötyypit`,   
    }
}

export const initTranslations = localTranslations => translations = { ...globalTranslations, ...localTranslations }

let language = 'en'

export const setLanguage = payloadLanguage => language = payloadLanguage

export const getAccountLanguage = () => document.querySelector('html').getAttribute('lang')

export const getCurrentLanguage = state => (state && state.radarSettings.radarLanguage)
    || getAccountLanguage()
    || 'en'

export const requestTranslation = (translation, parameter) => {
    if (!translations) {
        // if package doesn't have local translations initiate global translations (ie: ui package)
        initTranslations({})
    }

    if (!translation || !translations[translation]) {
        process.env.NODE_ENV !== 'production' && console.warn('[requestTranslation] was called with invalid parameters', translation)
        return
    }

    if (_.isFunction(translations[translation][language])) {
        return translations[translation][language](parameter)
    }

    return translations[translation][language]
}

export const defaultErrorMessage = whatWentWrong => {
    return language === 'en' ? `There was an error ${whatWentWrong}, please try again` : `Tapahtui virhe ${whatWentWrong}. Yritä uudelleen`
}

export const getLanguage = () => language

export const getAvailableLanguages = () => [
    { value: 'en', label: requestTranslation('english') },
    { value: 'fi', label: requestTranslation('finnish') }
]

export const radarLanguagesWithAll = () => [
    { value: 'all', label: requestTranslation('all') },
    ...getAvailableLanguages()
]
